module.exports = __webpack_public_path__ + "img/8.56365c80.jpg";